import "./QuestionsView.css";
import { Collapse } from "@geist-ui/react";
import { useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import axios from "axios";
import RenderPosts from "./RenderQuestions";

function QuestionsGen({ filter }) {
  const [cookies] = useCookies(["colabAuth"]);
  const [data, setData] = useState([]);

  useEffect(() => {
    const { token } = cookies.colabAuth;
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    (async () => {
      const {
        data,
        status,
      } = await axios.get(
        `https://eastern-surface-293816.el.r.appspot.com/api/posts/${filter}`,
        { headers }
      );

      if (status === 200) {
        console.log(data);
        setData(data);
      }
    })();
  }, [filter, cookies]);

  return (
    <Collapse.Group>
      <RenderPosts posts={data} />
    </Collapse.Group>
  );
}

export default QuestionsGen;
